import { IFormSection } from "../../types/common";
import { API_USSD_CONFIGURABLES } from "../../utils/apis";

export const useUSSDConfigurablesForm = () => {
  const sections: IFormSection[] = [
    {
      title: "USSD Configurables",
      fields: [
        {
          field_name: "name",
          type: "text",
          label: "Name",
          description: "Enter the name of the configurable.",
          props: { required: true },
        },
        {
          field_name: "value",
          type: "text",
          label: "Value",
          description: "Enter the value of the configurable.",
          props: { required: true },
        },
        {
          field_name: "is_hashed",
          type: "select",
          label: "Is Hashed",
          description: "Select whether the configurable is hashed.",
          props: {
            required: false,
            options: [
              { label: "Yes", value: true },
              { label: "No", value: false },
            ],
          },
        },
      ],
    },
  ];

  function onSubmit(payload: any, id: string | number) {
    let params = { ...payload };

    return {
      id,
      api: API_USSD_CONFIGURABLES,
      params,
    };
  }

  return { sections, onSubmit };
};
